import React from 'react';
import { toast } from 'react-toastify';

import Notification, { NotificationVariant } from 'components/widgets/Notification';

export const showNotification = (message: string, { variant }: { variant: NotificationVariant }) => {
  toast(<Notification message={message} variant={variant} />);
};
